import { render, staticRenderFns } from "./BWA.vue?vue&type=template&id=c92b8d0e&scoped=true&"
import script from "./BWA.vue?vue&type=script&lang=js&"
export * from "./BWA.vue?vue&type=script&lang=js&"
import style0 from "./BWA.vue?vue&type=style&index=0&id=c92b8d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92b8d0e",
  null
  
)

export default component.exports